// 对应 sidebar-07 的 TeamSwitcher：切换个人空间 / 战队空间。
import { ChevronsUpDown, Plus, User as UserIcon } from "lucide-react";
import { useNavigate } from "react-router";
import { Avatar } from "@/components/ui/avatar";
import { MenuContent, MenuItem, MenuLabel, MenuRoot, MenuSep, MenuTrigger } from "@/components/ui/menu";
import { SidebarMenu, SidebarMenuButton, SidebarMenuItem, useSidebar } from "@/components/ui/sidebar";
import { useMe } from "@/lib/auth/session";
import { roleLabel } from "@/lib/format";
import { spaceName, useSpace } from "@/lib/space";

export function SpaceSwitcher() {
  const me = useMe();
  const { space, setSpace } = useSpace();
  const { isMobile } = useSidebar();
  const navigate = useNavigate();
  const name = spaceName(space);
  const sub = space.kind === "team" ? `战队空间 · ${roleLabel[space.team.role]}` : "个人空间";

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <MenuRoot>
          <MenuTrigger asChild>
            <SidebarMenuButton size="lg" aria-label={`切换空间：${name}`} className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground">
              <span className="flex aspect-square size-8 items-center justify-center rounded-md bg-sidebar-primary font-display text-sm font-semibold text-sidebar-primary-foreground">
                {space.kind === "team" && space.team.avatar_url ? (
                  <img src={space.team.avatar_url} alt="" className="size-8 rounded-md object-cover" />
                ) : space.kind === "team" ? (
                  Array.from(space.team.name)[0]
                ) : (
                  <UserIcon className="size-4" />
                )}
              </span>
              <span className="grid flex-1 text-left leading-tight">
                <span className="truncate body-medium">{name}</span>
                <span className="truncate caption muted">{sub}</span>
              </span>
              <ChevronsUpDown className="ml-auto muted" />
            </SidebarMenuButton>
          </MenuTrigger>
          <MenuContent align="start" side={isMobile ? "bottom" : "right"} sideOffset={4} label="切换空间" className="w-(--radix-dropdown-menu-trigger-width) min-w-56">
            <MenuLabel>切换空间</MenuLabel>
            <MenuItem onSelect={() => setSpace(null)}>
              <Avatar name={me.user.display_name} src={me.user.avatar_url} size="sm" />
              个人空间
              {space.kind === "personal" ? <span className="caption text-primary ml-auto">当前</span> : null}
            </MenuItem>
            {me.teams.map((t) => (
              <MenuItem key={t.id} onSelect={() => setSpace(t.id)}>
                <Avatar name={t.name} src={t.avatar_url} size="sm" />
                <span className="truncate-1">{t.name}</span>
                {space.kind === "team" && space.team.id === t.id ? (
                  <span className="caption text-primary ml-auto">当前</span>
                ) : (
                  <span className="caption muted ml-auto">{roleLabel[t.role]}</span>
                )}
              </MenuItem>
            ))}
            <MenuSep />
            <MenuItem icon={<Plus className="ico" />} onSelect={() => navigate("/teams?create=1")}>
              <span className="muted">创建战队</span>
            </MenuItem>
          </MenuContent>
        </MenuRoot>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
